module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_UAE.bb6c06ec.txt";